export const DefaultFloatingBannerId = 'floatingBannerId';
